<template>
  <mdb-container fluid>
    <mdb-row>
      <mdb-col md="12"> <div id="map"></div></mdb-col>
    </mdb-row>
  </mdb-container>
</template>
<script>
import { start } from "../common/utilities/mapController";

export default {
  name: "CoverageMap",
  mounted() {
    start();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map {
  position: relative;
  margin: auto;
  width: 80%;
}
</style>
